import { render, staticRenderFns } from "./DataAccessSubscriptionPaymentPopup.vue?vue&type=template&id=4481aa06&scoped=true&"
import script from "./DataAccessSubscriptionPaymentPopup.vue?vue&type=script&lang=js&"
export * from "./DataAccessSubscriptionPaymentPopup.vue?vue&type=script&lang=js&"
import style0 from "./DataAccessSubscriptionPaymentPopup.vue?vue&type=style&index=0&id=4481aa06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481aa06",
  null
  
)

export default component.exports